import React from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const styles = {
    modalContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1300,
        padding: '20px'
    },
    closeButton: {
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1400
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain'
    }
};
const PreviewModal = ({ open, onClose, imageUrl, altText }) => {
    const handleContainerClick = (event) => {
        if (event.target.id === 'preview-modal') {
            onClose();
        }
    };
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="preview-modal"
            aria-describedby="preview-modal-description"
        >
            <div
                id="preview-modal"
                data-automation="preview-modal"
                style={styles.modalContainer}
                onClick={handleContainerClick}
            >
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    data-automation="preview-close"
                    style={styles.closeButton}
                >
                    <CloseIcon />
                </IconButton>

                <img
                    loading="lazy"
                    src={imageUrl}
                    alt={altText || 'Preview Image'}
                    style={styles.image}
                />
            </div>
        </Modal>
    );
};

export default PreviewModal;
